var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('div',{ref:"echarts",staticClass:"echartsContainer"})])
}
var staticRenderFns = []

export { render, staticRenderFns }